<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Managed Channels <span v-if="user"> for {{ user.email }}</span></p>
          <div class="float-right">
            <Filters @filter-changed="onFilterChanged" />
            <el-tooltip content="Insert" placement="top">
              <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table :user="user" />
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import Table from '../components/mcn-channels/ChannelTable.vue'
import Dialog from '../components/mcn-channels/ChannelDialog.vue'
import Filters from '../components/mcn-channels/McnFilter.vue'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
    }
  },
  components: {
    Table,
    Dialog,
    Filters,
  },

  computed: {
    ...mapState('mcnChannels', ['loading'])
  },

  methods: {
    ...mapMutations('mcnChannels', [
      'setDialog',
      'setFilter',
    ]),
    ...mapActions('mcnChannels', [
      'read'
    ]),
    insert(){
      this.setDialog(true)
    },
    onFilterChanged(filter) {
      this.setFilter(filter); // Update filter state in Vuex
      this.read(); 
    },
    created() {
      this.read();
    },

  }
}
</script>
